<template>
  <v-card elevation="3" class="rounded-xl">
    <v-card-title v-if="shouldShowTitle">
      Admissions
      <v-icon :class="titleIconClass" :size="titleIconSize"></v-icon>
      <span :class="titleTextClass">{{ titleText }}</span>
    </v-card-title>
    <v-alert type="info" v-if="isEmptyData">No Data for selected graph</v-alert>
    <v-card-title v-if="isEmptyChartValues">
      Admissions
      <v-divider class="my-2"></v-divider>
    </v-card-title>

    <line-chart :data="dataCollection" :options="chartOptions" :chart="'admissions'" />
  </v-card>
</template>

<script>
import LineChart from '../charts/LineChart';

export default {
  components: {
    LineChart,
  },
  props: ['chartData'],
  data() {
    return {
      dataCollection: null,
      chartMonths: [],
      chartValues: [],
      lineColor: '#e2175b',
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        legend: { display: false },
        scales: {
          xAxes: [
            {
              gridLines: {
                color: 'rgba(61, 97, 133, 0.25)',
                display: true,
                drawBorder: false,
                drawTicks: false,
              },
              ticks: { padding: 10 },
            },
          ],
          yAxes: [
            {
              scaleLabel: { display: true, labelString: '# of Admissions' },
              gridLines: { display: false },
            },
          ],
        },
      },
    };
  },
  computed: {
    shouldShowTitle() {
      return this.percentDif !== 0 && this.chartValues.length > 0;
    },
    titleIconClass() {
      return this.percentDif > 0
        ? 'mdi-arrow-down success--text mb-1'
        : 'mdi-arrow-up error--text mb-1';
    },
    titleIconSize() {
      return 15;
    },
    titleTextClass() {
      return this.percentDif > 0 ? 'success--text' : 'error--text';
    },
    titleText() {
      return this.percentDif > 0 ? `${this.percentDif}%` : `${Math.abs(this.percentDif)}%`;
    },
    isEmptyData() {
      return this.chartValues.length === 0;
    },
    isEmptyChartValues() {
      return this.chartValues.length < 1;
    },
  },
  watch: {
    chartData: {
      handler: 'updateChartData', // Call the updateChartData method
      immediate: true, // Call the handler immediately when the prop changes
    },
  },
  methods: {
    updateChartData() {
      console.log('here we are.+');
      if (!this.chartData || this.chartData.length === 0) {
        console.log('No chart data available yet.');
        return; // Exit the function if chartData is not available or empty
      }
      console.log('Updating chart data:', this.chartData);
      // Extracting the months and admissionsTotal values
      this.chartMonths = this.chartData.map((info) => info.month);
      this.chartValues = this.chartData.map((info) => info.admissionsTotal);

      this.calculatePercentDif();
      this.prepareChartData();
    },
    calculatePercentDif() {
      const firstVal = this.chartValues[0] || 0;
      const lastVal = this.chartValues[this.chartValues.length - 1] || 0;
      const decreaseValue = firstVal - lastVal;
      this.percentDif =
        firstVal !== 0
          ? Math.ceil((decreaseValue / firstVal) * 100)
          : Math.ceil(decreaseValue * 100);
    },
    prepareChartData() {
      this.dataCollection = {
        labels: this.chartMonths,
        datasets: [
          {
            label: 'Admissions',
            borderColor: this.lineColor,
            pointBackgroundColor: this.lineColor,
            borderWidth: 3,
            data: this.chartValues,
          },
        ],
      };
    },
  },
};
</script>
